import { withStyles } from '@material-ui/core/styles';
import { Paper as PaperCore } from '@material-ui/core';
import * as lib from '~/dependencies';

export const StyledPaper = lib.styled(PaperCore)`
    height: 100px !important;
    display: flex !important;
    flex-wrap: wrap !important;
    justify-content: space-around;
    align-items: center;
    padding: 5px 10px ;
  `;

export const Paper = withStyles(theme => ({
  root: {
    boxShadow: theme.shadows[3],
    backgroundColor: '#f9f9f9',
  },
}))(StyledPaper);
